<template>    
    <v-container fluid  class="main">
      <LeftMenu/>  
       <v-layout row wrap>  
           <Progress :show="this.showProgress" />
           <v-flex xs1></v-flex>
            <v-flex xs11>
                <v-row
                    class="mb-6"
                    no-gutters
                >
                    <v-col md="7" class="pa-2" >
                        <v-layout wrap>
                            <v-flex xs12 sm6 md6>
                                <v-combobox
                                :items="customers"
                                label="Select Customer"
                                v-model="offer.customer"
                                item-text="customerName"
                                single-line
                                return-object
                                >
                                <template slot="selection" slot-scope="data">
                                    {{ data.item.customerName }}  - {{ data.item.company }}
                                </template>
                                <template slot="item" slot-scope="data">
                                    {{ data.item.customerName }}  - {{ data.item.company }}
                                </template>
                                </v-combobox>
                            </v-flex>
                            <v-flex xs12 sm6 md2>
                                <v-text-field v-model="this.offerWithStatus.status" :disabled="true" label="Status"></v-text-field>
                            </v-flex> 
                            <v-flex xs12 sm6 md1>
                                <v-btn v-if=" isOfferEditable(offer) &&  offerHasPriceModel(offer)" 
                                            color="warning" dark class="mb-2" @click="createVersion(offer)">Version</v-btn>
                            </v-flex>
                            <v-flex xs12 sm6 md1/>
                            <v-flex xs12 sm6 md2>
                                <v-btn v-if="isOfferEditable(offer) &&  offerHasPriceModel(offer)" 
                                        color="primary" dark class="mb-2" @click="convertToSale(offer)">To Sale</v-btn>
                            </v-flex>


                            <v-flex xs12 sm6 md3>
                                <DatePicker picker-label="Offer Date" :date-value="offer.offerDate" @dateSelected="offer.offerDate=$event" />                              
                            </v-flex>  
                            <v-flex xs12 sm6 md1/>
                            <v-flex xs12 sm3 md3 >
                                <v-combobox
                                :items="salePersonnels"
                                label="Select Salesman"
                                v-model="offer.salePersonnel"
                                item-text="name"
                                single-line
                                return-object
                                ></v-combobox>
                            </v-flex>                   
                            <v-flex xs12 sm6 md1>
                            </v-flex> 
                            <v-flex xs12 sm6 md3>
                                <DatePicker v-if="showSaleDate" picker-label="Sale Date" :date-value="saleDate" @dateSelected="saleDate=$event" />                              
                            </v-flex>  
                            <v-flex xs12 sm6 md1/>   


                            <v-flex xs12 sm6 md3>	
                                <v-combobox	
                                    :items="currencyListWithText"	
                                    label="Select Currency"	
                                    v-model="offer.currency"	
                                    item-text="text"	
                                    single-line	
                                    return-object>	
                                </v-combobox>	
                            </v-flex> 
                            <v-flex xs12 sm6 md1/>
                            <v-flex xs12 sm6 md3>
                                <v-text-field v-model="offer.validityDays" label="Validity Days"></v-text-field>
                            </v-flex>  
                            <v-flex xs12 sm6 md1/>
                            <v-flex xs12 sm6 md3>
                                <v-currency-field v-if="showSaleDate" v-model="taxAmount"  label="Tax Amount"></v-currency-field>
                            </v-flex> 
                            <v-flex xs12 sm6 md1/>

                            <v-flex xs12 sm6 md11>
                                <v-textarea v-model="offer.explanation"  :outlined="true"
                                :auto-grow="true" :clearable="true"
                                label="Explanation"></v-textarea>
                            </v-flex>   
                            <v-flex xs12 sm6 md11/>
                        </v-layout>
                    </v-col>
                    <v-col md="5" class="pa-2" >
                        
                            <v-layout row wrap>                                         
                                <v-flex xs12 >
                                    <Documents :documents="this.offer.documents" master-category="OFFER" :folder-id="this.offer.folderId"
                                               :parentRecord="this.offer.id" :readonly="this.offer.id == 0" @documentsChanged="getOffer" />
                                </v-flex>                                            
                            </v-layout>      
                    </v-col>
                </v-row>
                <v-layout wrap >   
                    <v-flex v-if="offer.id" xs12 sm6 md6>
                        <v-combobox
                        :items="priceModelListWithText"
                        label="Select Price Model"
                        v-model="newPriceModel.priceModel"
                        item-text="modelName"     
                        item-value="id"       
                        v-on:change="priceModelSelected"                     
                        chips
                        return-object
                        ></v-combobox>
                    </v-flex>   
                    <v-flex v-if="offer.id" xs12 sm6 md1>
                        <v-text-field v-model="newPriceModel.quantity" :readonly="subProductSelected"  v-on:change="applyDiscount" label="Quantity"></v-text-field>
                    </v-flex>
                    <v-flex v-if="offer.id" xs12 sm6 md1>                              
                        <v-combobox
                            :items="discountPercentages"
                            label="Select Discount"
                            v-model="selectedDiscountRate"
                            item-text=""
                            v-on:change="applyDiscount"
                            single-line
                            return-object
                        ></v-combobox>
                    </v-flex> 
                    <v-flex v-if="offer.id" xs12 sm6 md2>
                        <v-currency-field :key="newPriceModel.id" v-model="newPriceModel.discountRate" :readonly="subProductSelected" label="Discount Amount"></v-currency-field>
                    </v-flex>
                    <v-flex v-if="offer.id" xs12 sm6 md2>                              
                        <v-btn v-if="isOfferEditable(offer)" color="primary" dark class="mb-2" @click="addPriceModel(offer)">Add To Offer</v-btn>
                    </v-flex> 
            
                    
                    <v-flex v-if="offer.id && loaded" xs12 sm6 md12>
                        <v-data-table
                            :key="priceModelTableKey"
                            :headers="priceModelHeaders"
                            :items="offer.priceModels"
                            item-key="priceModel.id"
                            sort-by="priceModel.modelName"                                    
                            class="elevation-1"
                            hide-default-footer
                            >
                        <template v-slot:item.priceModelAction="{ item }">                                                  
                            <v-icon   
                            :disabled="!isOfferEditable(offer)"                                 
                            @click="deletePriceModel(item)"
                            >
                            mdi-delete
                            </v-icon>
                        </template>
                        </v-data-table>
                    </v-flex>  
                    <v-spacer></v-spacer>
                    <v-flex xs12 sm6 md8></v-flex> 
                    <v-flex xs12 sm6 md2>
                        <b>Offer Total Amount : </b>
                    </v-flex>  
                    <v-flex xs12 sm6 md2 >
                        <b>{{ totalOfferPriceFormatted }} {{offerCurrency}}</b>
                    </v-flex>  
                    <v-flex xs12 sm6 md12>
                        <v-expansion-panels>
                            <v-expansion-panel v-if="offerHasPriceModel(offer)">
                                <v-expansion-panel-header>
                                    TERMS AND CONDITIONS
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-textarea
                                        v-if="offerHasPriceModel(offer)"
                                        rows="20"
                                        v-model="offer.terms"  :outlined="true" :clearable="true"
                                        label="">
                                    </v-textarea>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-flex>  
                    <v-flex xs12 sm6 md12 />
                    <v-flex xs12 sm6 md10 />
                    <v-flex xs12 sm6 md1>
                    </v-flex>  
                    <v-flex xs12 sm6 md1>
                        <v-btn v-if="isOfferEditable(offer)" color="success" dark class="mb-2" @click="save">Save Offer</v-btn>   
                    </v-flex> 
                </v-layout>
            </v-flex>
       </v-layout>
    </v-container>
</template>
<script>
import LeftMenu from '../components/LeftMenu';
import DatePicker from '../components/DatePicker';
import Progress from '../components/Progress';
import Documents from '../views/Documents';
import breadcrumbs from '../store/breadcrumbs.js'
import formatPrice from '../helpers/formatter';
import getCurrentDate from '../helpers/getCurrentDate';
const OFFER_API_URL = 'offers';
const CUSTOMERS_API_URL = 'definitions/customers';
const CURRENCIES_API_URL = 'definitions/currencies';
const SALESMAN_API_URL = 'definitions/personnel/department/sales';
const PRICE_MODELS_API_URL = 'definitions/priceModels';
const SALES_API_URL  = 'sales';
const CURRENCY_RATE_API_URL = 'definitions/currencyRates/getByDateAndCurrencyCode';
export default {
    props: {
    },
    components:{
      LeftMenu,
      DatePicker,
      Documents,
      Progress
    },
    data () {
      return {
        loaded: false,
        showProgress : false,
        customers:[],
        offer : {},
        priceModelTableKey : 0,
        salePersonnels: [], 
        discountPercentages: [],
        selectedDiscountRate : '',
        subProductSelected: false,
        priceModels:[],
        currencyList: [],
        showSaleDate: false,
        saleDate: '',
        taxAmount: 0,
        totalOfferPrice: 0,
        offerCurrency : '',
        newPriceModel:{},
        currentDiscountRate: 1
      }
    },
    computed: {      
        priceModelHeaders(){
            return [   
                { text: 'Price Model',  value: 'longText'  },      
                { text: 'Quantity',  value: 'quantity', align: 'center'  },
                { text: 'Original Price',  value: 'basePriceWithCurrency', align: 'right'  },
                { text: 'Converted(' + this.offer.currency.code +')',  value: 'convertedAmountFormatted', align: 'right'  },
                { text: 'Discount(' + this.offer.currency.code +')',  value: 'discountRateFormatted', align: 'right'  }, 
                { text: 'Total Price(' + this.offer.currency.code +')',  value: 'totalPriceFormatted' , align: 'right' }, 
                { text: 'Actions', value: 'priceModelAction', sortable: false },
            ]
        },
        priceModelListWithText(){
            return this.priceModels.map((item) => {           
                item.modelName = item.modelName+' - '+ item.product.model +' - '+ item.unitValue +' '+ item.product.unit.text +' - ' + item.amount +' '+item.currency.code;        
                return item;    
            })
        }, 
        discountText(){
            return "Discount ("+this.offer.currency.code+')';
        },
        totalOfferPriceFormatted(){
            return formatPrice(this.totalOfferPrice);
        },
        convertedText(){
            return "Converted ("+this.offer.currency.code+')';
        },
        offerWithStatus(){
            if(this.offer.status=="OPEN"){
                let validityDays = this.offer.validityDays;
                if(!this.offer.validityDays)   {
                    validityDays = 0;
                }   
                let offerExpireDate = new Date(this.offer.offerDate);
                offerExpireDate.setDate(offerExpireDate.getDate()+validityDays);
                var today = new Date();
                if(today > offerExpireDate) {
                    this.offer.status = "EXPIRED";
                }
            }
            return this.offer;
        },
        currencyListWithText(){
            return this.currencyList.map((item) => {
                return {
                id: item.id,
                code: item.code,
                text: item.code+' - '+item.text          
                };
            })
        },
    },
    created () {
        if(this.$route.params.id != 'new'){
            this.getOffer(); 
        }else{
            this.offer.id= 0;
            this.offer.status = "OPEN";
            this.totalOfferPrice = 0;
            this.offer.customer = {};
            let currentCustomer = breadcrumbs.getters.getCustomer;
            let crumbs = breadcrumbs.getters.getBreadCrumps;
            if( crumbs && crumbs.length>0 && currentCustomer){
                this.offer.customer = currentCustomer;
            }
        }
        this.getCustomers();
        this.getCurrencies()
        this.getSalePersonnels();
        this.getPriceModels();
        this.fillDiscountRates();
        this.newPriceModel = {}; 
    },
    methods: {
        async getOffer(){
          this.$axios.get(this.$apiurl + OFFER_API_URL+'/'+ this.$route.params.id)
            .then(response => {
                this.offer = response.data;
                this.offerCurrency = this.offer.currency.code;
                this.updateBreadCrumbs(response.data);
                this.getOfferPriceModels();
                this.getCurrencyRate();
            }) 
            .catch(error => {
                console.log(error);
            });   
        },
        isOfferEditable(offer){
            return offer.status=='OPEN' || offer.status=='EXPIRED';
        },
        offerHasPriceModel(offer){
            return offer.id >0 && offer.priceModels && offer.priceModels.length > 0;
        },
        getCustomers(){     
          this.$axios.get(this.$apiurl + CUSTOMERS_API_URL)
            .then(response => {
                this.customers = response.data;
            }) 
            .catch(error => {
                console.log(error);
            });                         
        },   
        getSalePersonnels(){     
          this.$axios.get(this.$apiurl + SALESMAN_API_URL)
            .then(response => {
                this.salePersonnels = response.data.filter(x=>x.leaveDate==null);
            }) 
            .catch(error => {
                console.log(error);
            });                         
        },
        async getSelectedOfferTerms(){
          await this.$axios.get(this.$apiurl + OFFER_API_URL+'/'+this.$route.params.id+'/terms')
            .then(response => {
            if(response.data && response.data.length>0){
                this.offer.terms = response.data;
            }
            }) 
            .catch(error => {
                console.log(error);
            });  
        },
        save () {
            if(!this.offer.customer){
                alert('Customer cannot be empty!');
                return;
            } 
            if(!this.offer.salePersonnel){
                alert('Sale personnel cannot be empty!');
                return;
            }  
            if(!this.offer.status){
                alert('Status cannot be empty!');
                return;
            } 
            if(!this.offer.offerDate){
                alert('Offer date cannot be empty!');
                return;
            } 
            if(!this.offer.validityDays){
                alert('Validity days cannot be empty!');
                return;
            }
            if(!this.offer.currency){
                alert('Currency  cannot be empty!');
                return;
            }
            if (this.$route.params.id != 'new') {        
                this.updateOffer(this.offer);
            } else {
                this.addOffer(this.offer);         
            }  
        },
        addOffer(item){
            this.showProgress = true;
            this.$axios.post(this.$apiurl + OFFER_API_URL, {
                customerId: item.customer.id,  
                salePersonnelId: item.salePersonnel ? item.salePersonnel.id : null,
                currencyId: item.currency.id,
                offerNo: item.offerNo,      
                offerDate: item.offerDate,
                validityDays: item.validityDays,
                status: item.status,
                explanation: item.explanation,
                terms: item.terms,
                newVersion: false,
                priceModels: item.priceModels
            })
            .then(response => {        
                if (response.status === 201) {
                this.offer = response.data;
                this.updateBreadCrumbs(response.data);
                this.showProgress = false;
                this.$radio.$emit('success', {message:'Offer Created Successfully'});
                this.$router.push('/offers/'+this.offer.id);
                } 
            }) 
            .catch(error => {
                console.log(error);
            }); 
        },
        updateOfferStatus(status){
            this.$axios.post(this.$apiurl + OFFER_API_URL+'/'+this.$route.params.id+'/status/'+status, {})
            .then(response => {        
                if (response.status === 200) {
                } 
            }) 
            .catch(error => {
                console.log(error);
            }); 
            },
        async applyDiscount(){
            if(this.selectedDiscountRate && this.newPriceModel && this.newPriceModel.priceModel && this.newPriceModel.priceModel.amount ){
                this.newPriceModel.discountRate =  this.currentDiscountRate * this.newPriceModel.priceModel.amount * this.selectedDiscountRate * this.newPriceModel.quantity / 100;
            }    
        },
        async addPriceModel(offer){
        
            await this.$axios.post(this.$apiurl + OFFER_API_URL+'/'+this.$route.params.id+'/priceModels', {
                priceModelId: this.newPriceModel.priceModel.id,        
                discountRate: this.newPriceModel.discountRate ? this.newPriceModel.discountRate : 0,
                quantity: this.newPriceModel.quantity ? this.newPriceModel.quantity : 1
            })
            .then(response => {        
                if (response.status === 201) {
                    this.$radio.$emit('success', {message:'Price Model Added Sucessfully'});
                } 
            }) 
            .catch(error => {
                console.log(error);
            });      
            this.newPriceModel = {};
            this.selectedDiscountRate = '';
            await this.getSelectedOfferTerms();
            await this.getOfferPriceModels();      
        },
        updateOffer(item){
            this.$axios.put(this.$apiurl + OFFER_API_URL, {
                id: item.id,
                customerId: item.customer.id,
                salePersonnelId: item.salePersonnel ? item.salePersonnel.id : null,
                currencyId: item.currency.id,
                userId: item.user.id,
                offerDate: item.offerDate,
                validityDays: item.validityDays,
                status: (item.status == "EXPIRED") ? "OPEN" : item.status,
                explanation: item.explanation,
                terms: item.terms,
                newVersion: false,
                priceModels: item.priceModels
            })
            .then(response => {
                if (response.status === 200) {
                    this.$radio.$emit('success', {message:'Offer Saved Sucessfully'});
                }         
            }) 
            .catch(error => {
                console.log(error);
            }); 
        },
        async getOfferPriceModels(){  
            this.offer.priceModels = [];
            this.priceModelTableKey +=1;      
            this.totalOfferPrice = "";
            
            await this.$axios.get(this.$apiurl + OFFER_API_URL+'/'+this.$route.params.id+'/priceModels')
            .then(response => {
                if(response.data && response.data.length>0){
                    this.offer.priceModels = response.data;              
                    this.offer.priceModels.map((item) => {           
                        item.basePriceWithCurrency = item.priceModel.amount * item.quantity+' '+ item.priceModel.currency.code;  
                        item.convertedAmountFormatted  = formatPrice(item.convertedAmount);
                        item.discountRateFormatted = formatPrice(item.discountRate);
                        item.totalPriceFormatted = formatPrice(item.totalAmount);
                        item.longText =  item.priceModel.modelName+' - '+ item.priceModel.product.model +' - '+ item.priceModel.unitValue +' '+ item.priceModel.product.unit.text +' - ' + item.priceModel.amount +' '+item.priceModel.currency.code
                        return item;    
                    });
                    this.totalOfferPrice =  this.offer.priceModels.reduce((acc, item) => acc + item.totalAmount, 0); 
                }
            }) 
            .catch(error => {
                console.log(error);
            });   
            
            if(!this.offer.terms || this.offer.terms.length ==0){
                await this.getSelectedOfferTerms();
            }
            this.loaded = true;
        },
        fillDiscountRates(){
            for (var i = 1; i < 100; i++) {
                this.discountPercentages.push(i);
            }
        },
        getPriceModels(){     
            this.$axios.get(this.$apiurl + PRICE_MODELS_API_URL + '/status/'+true)
                .then(response => {
                    this.priceModels = response.data;                                
                }) 
                .catch(error => {
                    console.log(error);
                });                         
        }, 
        priceModelSelected(item){  
            this.subProductSelected = false; 
            if(item.product.category.main == 0){
                this.subProductSelected = true;
                this.newPriceModel.quantity = 1;
                this.newPriceModel.discountRate = 0;
            }
        },
        createVersion(item){
            if(!this.offer.priceModels || this.offer.priceModels.length<1){
                alert ('Offer should have at least a price model?');
                return;
            }      
            if(confirm('Are you sure you want to create version to offer?')){        
                this.createVersionOfOffer(item);
            } 
        },
        convertToSale(item){
            if(!this.showSaleDate){
                this.showSaleDate = true;
                return;
            }
            if(!this.saleDate){
                alert ('You should select a sale date!');
                return;
            }
            if(!this.offer.priceModels || this.offer.priceModels.length<1){
                alert ('Offer should have at least a price model?');
                return;
            }      
            if(confirm('Are you sure you want to convert offer to sale?')){        
                this.convertOfferToSale(item);
            } 
        },
        createVersionOfOffer(item){
            this.showProgress = true;
            this.$axios.post(this.$apiurl + OFFER_API_URL, {
                id:item.id,
                offerNo: item.offerNo,
                customerId: item.customer.id,    
                salePersonnelId: item.salePersonnel ? item.salePersonnel.id : null,   
                offerDate: item.offerDate,
                validityDays: item.validityDays,
                status: item.status,
                explanation: item.explanation,
                terms: item.terms,
                newVersion: true,        
                currencyId: item.currency.id,
                priceModels: item.priceModels
            })
            .then(response => {        
                if (response.status === 201) {
                    this.updateBreadCrumbs(response.data)
                    this.updateOfferStatus("REVISED");
                    this.showProgress = false;
                    this.$radio.$emit('success', {message:'New Version Created Successfully'});
                    this.$router.push('/offers/'+response.data.id);
                } 
            }) 
            .catch(error => {
                console.log(error);
            });
        }, 
        updateBreadCrumbs(item){
            let offerText = item.offerNo;
            if(item.versionNo>0){
                offerText += ' - '+item.versionNo ;
            }
            breadcrumbs.dispatch('setBreadCrumps', [
                                      { text: 'Customers', disabled: false, href: '/#/customers'},
                                      { text: item.customer.customerName, disabled: false, href: '/#/customers/'+item.customer.id},
                                      { text: 'Offer ' +offerText, disabled: true } // placeholder
                                  ]);
        },
        convertOfferToSale(item){
            this.showProgress = true;
            this.$axios.post(this.$apiurl + SALES_API_URL, {
                offerId: item.id,
                currencyId: item.currency.id,
                salePersonnelId: item.salePersonnel ? item.salePersonnel.id : null,
                customerId: item.customer.id,
                explanation: item.explanation,
                saleDate: this.saleDate,
                taxAmount: this.taxAmount,
                amount: this.taxAmount ? this.totalOfferPrice + this.taxAmount : this.totalOfferPrice,
            })
            .then(response => {        
                if (response.status === 201) {  
                    this.showProgress = false;
                    this.updateOfferStatus("SOLD"); 
                    this.getOffer();
                    this.$radio.$emit('success', {message:'Converted To Sale Successfully'});
                } 
            }) 
            .catch(error => {
                console.log(error);
            }); 
        },
        async deletePriceModel(item){                  
            if(confirm('Are you sure you want to delete this price model?')){ 
                await this.$axios.delete(this.$apiurl + OFFER_API_URL+'/'+ this.$route.params.id +'/priceModels/'+item.id)
                .then(response => {        
                if (response.status === 200) {
                    this.$radio.$emit('success', {message:'Price Model Deleted Successfully'});
                } 
                }) 
                .catch(error => {
                console.log(error);
                });            
                await this.getOfferPriceModels();                 
            }     
        },
        getCurrencies(){     
            this.$axios.get(this.$apiurl + CURRENCIES_API_URL)
            .then(response => {
                this.currencyList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
        }, 
        getCurrencyRate(){
            let fromCurrency = 'USD';
            let toCurrency = this.offer.currency ? this.offer.currency.code: 'USD';
            if(fromCurrency != toCurrency){
                this.$axios.post(this.$apiurl + CURRENCY_RATE_API_URL, {
                    exchangeDate: getCurrentDate(),        
                    fromCurrency: fromCurrency,
                    toCurrency: toCurrency
                })
                .then(response => {
                    if(response.data ){
                        this.currentDiscountRate =  response.data.rate ;
                    }
                }) 
                .catch(error => {
                    console.log(error);
                }); 
            }
        }
    }
}
</script>